import { render, staticRenderFns } from "./MyChildren.vue?vue&type=template&id=98e7b6ea&"
import script from "./MyChildren.vue?vue&type=script&lang=js&"
export * from "./MyChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports